function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import MultiFilter from './MultiFilter';
import { getFormatedDate } from '../../utils';
const DateFilter = /*#__PURE__*/React.memo(props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const sorted = Object.keys(props.items).sort().reverse()
  // eslint-disable-next-line no-sequences
  .reduce((r, k) => (r[k] = props.items[k], r), {});
  const filterItems = [];
  // eslint-disable-next-line array-callback-return
  Object.keys(sorted).map(key => {
    filterItems.push({
      key,
      label: getFormatedDate(key, sitecoreContext.language, false)
    });
  });
  return /*#__PURE__*/React.createElement(MultiFilter, _extends({}, props, {
    formattedItems: filterItems
  }));
});
export default DateFilter;